import React, { useState, useEffect } from 'react';
import { useAccount } from 'wagmi';
import Fade from 'react-reveal/Fade';
import { Avatar } from '@mui/material';
import { getTopScores } from '../../web3/SFM-ScoreBoardContract_Utils';
import PromptLogin from '../PromptLogin';
import Loader from '../../components/Loader/loader';

function LeaderBoardList() {
  const { isConnected, address } = useAccount();
  const [topScores, setTopScores] = useState();

  const getScores = React.useCallback(async () => {
    if (isConnected) {
      let top = await getTopScores();
      //sort the array according to the score
      let sortedscore = top
        .filter(({ score }) => Number(score) > 0)
        .sort((a, b) => b.score - a.score);
      top && setTopScores(sortedscore);
    }
  }, [isConnected, address]);

  React.useEffect(() => {
    isConnected && getScores();
  }, [getScores]);

  return (
    <div className="community-area primary-bg pb-175">
      <div className="container">
        {isConnected ? (
          topScores ? (
            <Fade right delay={0.5}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="community-wrap">
                    <div className="table-responsive-xl">
                      {topScores && topScores.length > 0 ? (
                        <table className="table mt-0">
                          <thead>
                            <tr>
                              <th scope="col">Wallet</th>
                              <th scope="col">Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            {topScores.map((elem, index) => (
                              <tr key={index}>
                                <td scope="row">
                                  <div className="community-post-wrap">
                                    <div className="title-style-three text-center">
                                      <h2>{elem.address}</h2>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="title-style-three text-center">
                                    <h2>{elem.score}</h2>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <h4 className="text-center  text-dark">
                          No Scores Yet
                        </h4>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          ) : (
            <div className="row justify-content-center">
              <Loader />
            </div>
          )
        ) : (
          <PromptLogin />
        )}
      </div>
    </div>
  );
}

export default LeaderBoardList;
